import MarketingConsentScreen from 'features/plaid/screens/MarketingConsent/MarketingConsentScreen';

export default function PlaidMarketingConsentPage() {
  return <MarketingConsentScreen />;
}
